import { DNOTE_SERVICE_URL } from 'constants/urls';

import { Link as RouterLink } from 'react-router-dom';
import { Alert } from 'shared/mui/Alert/Alert';
import { CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { TextFieldWithCopyButton } from 'shared/mui/Fields';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Link } from 'shared/mui/Link/Link';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  apiKey?: string;
};

export const ApiClientsShowApiKeysFieldDialog: React.FC<Props> = ({ open, onClose, apiKey }) => {
  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <CardHeader
        appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
        title="Ключ API"
        titleSize="smallBold"
      />
      <CardContent sx={{ paddingBottom: '24px!important' }}>
        <Alert severity="info" sx={{ marginBottom: '16px' }}>
          Используйте внутренний сервис{' '}
          <Link
            component={RouterLink}
            sx={{ color: 'primary.main' }}
            target="_blank"
            to={DNOTE_SERVICE_URL}
          >
            DNOTE
          </Link>{' '}
          для передачи значения ключа API.
        </Alert>
        <TextFieldWithCopyButton
          disabled
          fullWidth
          size="small"
          value={apiKey || ''}
          variant="outlined"
        />
      </CardContent>
    </Dialog>
  );
};
